export function groupBy<T, K>(collection: readonly T[], predicate: (t: T) => K): ReadonlyMap<K, T[]> {
  const map = new Map<K, T[]>();

  for (const item of collection) {
    const key = predicate(item);
    const items = map.get(key) ?? [];
    items.push(item);
    map.set(key, items);
  }

  return map;
}
